// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a20fb60e","252":"e2325218","455":"8fac5df3","495":"5eb24b3e","977":"8e3f344d"}[chunkId] + ".chunk.js";
};